// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__gye8-","clinicsSelect":"TableHeading_clinicsSelect__18ghf"};